module.exports = __webpack_public_path__ + "static/img/pro7.f19230b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro7.png
// module id = 20S+
// module chunks = 0